import {
  Box,
  Theme,
  createStyles,
  makeStyles,
  Typography,
} from '@material-ui/core';
import colors from '../../../themes/main-colors';
import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import PlantIcon from '../../../static/plant.svg';
import InvoiceIcon from '../../../static/invoice.svg';
import { Link } from 'gatsby';
import ROUTES from '../../../routes';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import BarChartIcon from '@material-ui/icons/BarChart';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import useTPA from '../../need-more-time-to-pay/tpa/useTPA';
import { useApolloClient } from '@apollo/react-hooks';
import { getAccountDetailsForPaymentExtension } from '../../../queries/paymentExtension.query';
import {
  AccountDetail,
  PaymentExtensionEligibility,
  PaymentExtensionResponse,
} from '../../../__generated__/pge-types';
import { useAccountCustomerDashboard } from '../../../hooks/useAccountCustomerDashboard';
import useSelectedAccountParams from '../../../hooks/useSelectedAccountParams';
import { useIsMobile } from '../../../util/style-utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    blueSection: {
      background: colors.navBarHoverBackground,
      borderRadius: '3px',
    },
    blueSectionMob: {
      background: colors.navBarHoverBackground,
      borderRadius: '3px',
      paddingTop: '2px',
      paddingBottom: '2px',
    },
    whiteSection: {
      background: colors.white,
      margin: '1rem',
      borderRadius: '3px',
    },
    graySection: {
      background: colors.cloudGrey,
      paddingLeft: '1rem',
      paddingRight: '1rem',
      borderRadius: '3px',
      '& h6': {
        marginBottom: '-1rem',
      },
    },
    billingAndPayment: {
      color: colors.sparkBlue,
    },
    energyUsage: {
      color: colors.sparkBlue,
    },
    needMoreTime: {
      color: colors.sparkBlue,
    },
    buttonsNMTTPandEneryUseDetails: {
      color: colors.sparkBlue,
      marginLeft: 'inherit',
      marginRight: 'inherit',
    },
    chevronRightIconStyles: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '90%',
      paddingBottom: '0.5rem',
      marginLeft: '1rem',
      color: colors.noirBlur,
    },
    buttonStyles: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: colors.white,
      marginLeft: '1rem',
      marginRight: '1rem',
      marginTop: '0.3rem',
      borderRadius: '5px',
      height: '40px',
    },
  }),
);

export const EnergySavingsTips = () => {
  const classes = useStyles();
  const { t, richT } = useTranslation();
  const isMobile = useIsMobile();
  const { tpaDetails } = useTPA({ shouldRedirect: false });
  const apolloClient = useApolloClient();
  const { showLegacyUI } = useAccountCustomerDashboard();
  const { accountParams } = useSelectedAccountParams();
  const [paymentExtentionData, setPaymentExtentionData] = useState<
    PaymentExtensionResponse | undefined
  >();
  useEffect(() => {
    const fetchPaymentExtensionDetails = async () => {
      const result = await apolloClient.query<{
        getAccountDetails: Array<AccountDetail>;
      }>({
        query: getAccountDetailsForPaymentExtension,
        variables: {
          params: {
            accountNumberList: [accountParams],
          },
        },
        fetchPolicy: 'network-only',
      });
      const paymentExtensionInfo =
        result?.data?.getAccountDetails?.[0]?.paymentExtensionInfo;
      setPaymentExtentionData(paymentExtensionInfo!);
    };
    !showLegacyUI && void fetchPaymentExtensionDetails();
  }, [showLegacyUI]);

  return (
    <>
      <div className={isMobile ? classes.blueSectionMob : classes.blueSection}>
        <div className={classes.whiteSection}>
          <div style={{ margin: '1rem', paddingTop: '1rem' }}>
            <Box className={classes.graySection}>
              <Typography style={{ paddingTop: '1px' }}>
                {richT('EASY_ENERGY_SAVING_TIPS')}
              </Typography>
              <Typography
                variant="subtitle1"
                style={{ marginBottom: '0px !important' }}
              >
                {richT('OPTIMIZE_YOUR_ENERY_TEXT')}
              </Typography>
              <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                <PlantIcon />
              </div>
            </Box>
          </div>
          <Link style={{ textDecoration: 'none' }} to={ROUTES.MY_WAYS_TO_SAVE}>
            <div className={classes.chevronRightIconStyles}>
              <Typography>{t('MY_WAYS_TO_SAVE')}</Typography>

              <ChevronRightIcon />
            </div>
          </Link>
        </div>
        <Box style={{ marginBottom: '1rem' }}>
          <div className={classes.buttonStyles}>
            <InvoiceIcon style={{ height: '35px' }} />
            <Link
              style={{ textDecoration: 'none' }}
              to={ROUTES.PAYMENT_HISTORY}
              className={classes.billingAndPayment}
            >
              <Typography variant="subtitle2">
                {t('BILLING_PAYMENT_HISTORY')}
              </Typography>
            </Link>
          </div>
          <div className={classes.buttonStyles}>
            <BarChartIcon
              fontSize="large"
              className={classes.buttonsNMTTPandEneryUseDetails}
            />
            <Link
              style={{ textDecoration: 'none' }}
              to={ROUTES.MY_ENERGY_USE}
              className={classes.energyUsage}
            >
              <Typography variant="subtitle2">
                {t('MY_ENERGY_USE_DETAILS')}
              </Typography>
            </Link>
          </div>
          {(tpaDetails
            ? tpaDetails?.isEnrolled ||
              tpaDetails?.isEligible ||
              (paymentExtentionData &&
                (paymentExtentionData?.eligibility! !==
                  PaymentExtensionEligibility.Ineligible ||
                  paymentExtentionData?.isEnrolled!))
            : false) && (
            <div className={classes.buttonStyles}>
              <AccessTimeIcon
                fontSize="large"
                className={classes.buttonsNMTTPandEneryUseDetails}
              />
              <Link
                style={{ textDecoration: 'none' }}
                to={ROUTES.NEED_MORE_TIME_TO_PAY}
                className={classes.needMoreTime}
              >
                <Typography variant="subtitle2">{t('NMTTP')}</Typography>
              </Link>
            </div>
          )}
        </Box>
      </div>
    </>
  );
};
